import { Card, Grid, Icon, MenuItem, Select, Tooltip } from "@mui/material";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import GeneralLayout from "components/LayoutContainers/GeneralLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

function EventosClientes() {


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <Grid container spacing={2} p={3}>
                            <Grid item xs={12}>
                                <SoftBox
                                    display={{
                                        xs: "flex-row",
                                        sm: "flex",
                                    }}
                                    justifyContent="space-between"
                                    alignItems="center"
                                    gap={1}
                                >
                                    <SoftBox
                                        flex={1}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <SoftTypography variant="h6">Clientes de eventos</SoftTypography>
                                        <Tooltip title="Filtrar">
                                            <SoftButton
                                                color="dark"
                                                circular
                                                iconOnly
                                                // onClick={() => setOpenFilters(!openFilters)}
                                            >
                                                {/* <Icon>{openFilters ? "filter_list_off" : "filter_list"}</Icon> */}
                                            </SoftButton>
                                        </Tooltip>
                                    </SoftBox>
                                </SoftBox>
                            </Grid>
                        </Grid>
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    )
}

export default EventosClientes